import { Box, Button, styled, Typography, Alert, Snackbar, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { EditHeader, ExeMenu, ExeTestCaseReportsTable, ReportSelection } from "./Reports";
import VisualAnalysisModal from "./Reports/VisualAnalysisModal";
import { IconContainer, IconContainerCircle, PageTitle } from "../components-new/common";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import { ContextIcon, ExportIcon, LogFileIcon, RefreshIcon } from "../components-new/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  useAnalysisQuery,
  useExecuteTCQuery,
  useFetchTestStepResultQuery,
  useFetchTestCaseResultQuery,
  useLastestResultQuery,
  useLatestResultByTestCaseQuery,
  useModuleQuery,
  useProductQuery,
  useSearchTestCaseRecordsQuery,
  useStopTestSuiteQuery,
  useTestCaseQuery,
  useTestCaseResultsQuery,
  useDebugMessageQuery,
  useDebugActionQuery,
  useGetStatusMessageQuery,
  useExecuteMobileTCQuery,
  useGetUIDesignIssuesQuery,
  useDownloadTestCaseQuery,
} from "../useQuery";
import {
  setTestCaseResults,
  setSelectedComponent,
  setSelectedProduct,
  setSelectedTestCase,
  resetExecutionReport,
  setIsDebugMode,
  setDebugStepNumber,
  setDebugMode,
  addExecutedStep,
} from "../Redux/ExecutionReport/ExecutionReportSlice";
import TestItemCard from "./Reports/TestItemCard";
import useTestStepSearchQuery from "../useQuery/useTestStepSearchQuery";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomBreadcrumbs from "../components-new/common/CustomBreadCrums";
import CustomDialog from "../components-new/common/CustomDialog";
import EditTabs from "./Studio/EditTabs";
import StatusBar from "./Studio/StatusBar";
import { useItemWidth, useNotification, useScrollPositionRestore } from "../hooks";
import { openAuthedResource } from "../utils/authedResource";

import Stop from "@mui/icons-material/Stop";
import DebugConfigModal from "./Studio/DebugConfigModal";
import ExecutionFlowModal from "../components-new/common/ExecutionFlowModal";
import AIStepsModal from "../components-new/common/AIStepsModal";
import TimelineIcon from "@mui/icons-material/Timeline";
import { setSelectedTestCaseName } from "../Redux/ExecutionReport/ExecutionReport";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const StyledButton = styled(Button)`
  padding: 15px 28px;
  border-radius: 8px;
  text-transform: capitalize;
`;

const DebugModeIndicator = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  backgroundColor: "#9C27B0",
  color: "white",
  padding: theme.spacing(1, 2),
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#7B1FA2",
  },
}));

const getDashboardScrollContainer = () =>
  document.querySelector('[data-testid="dashboard-layout"]');

const ExecutionReports = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(true);
  const [testCaseSearchKeyword, setTestCaseSearchKeyword] = useState("");

  const [debouncedSearchKeyword, setDebouncedSearchKeyword] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchKeyword(testCaseSearchKeyword);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [testCaseSearchKeyword]);
  const [editStep, setEditStep] = useState(false);
  const [editItemIndex, setEditItemIndex] = useState(null);
  const [currentEditItem, setCurrentEditItem] = useState(null);
  const [isExecute, setIsExecute] = useState(null);
  const [editCardData, setEditCardData] = useState([]);
  const containerRef = useRef(null);
  const previousProductRef = useRef("");
  const itemsPerRow = 4;
  const gap = 32;
  const itemWidth = useItemWidth(containerRef, itemsPerRow, gap);

  const dispatch = useDispatch();
  const notify = useNotification();
  const RouteState = useLocation();
  const navigate = useNavigate();

  const [isFiltered, setIsFiltered] = useState(false);
  const [isProductSetInitially, setIsProductSetInitially] = useState(false);
  const [showLatestRun, setShowLatestRun] = useState(true);
  const [isExecutionPending, setIsExecutionPending] = useState(
    Boolean(RouteState?.state?.isExecuteClick),
  );

  const selectedTestCase = useSelector((state) => state.executionSlice.selectedTestCase);
  const selectedProduct = useSelector((state) => state.executionSlice.selectedProduct);
  const selectedModule = useSelector((state) => state.executionSlice.selectedComponent);
  const testcaseResults = useSelector((state) => state.executionSlice.testCaseResults);
  const selectedTestCaseName = useSelector((state) => state.executionSlice.selectedTestCaseName);

  const [openStopDialog, setOpenStopDialog] = useState(false);
  const [showDebugPrompt, setShowDebugPrompt] = useState(false);
  const [debugMessage, setDebugMessage] = useState(null);
  const [selectedStepId, setSelectedStepId] = useState(null);

  const [showDebugIndicator, setShowDebugIndicator] = useState(false);
  const [debugActionReminder, setDebugActionReminder] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [showStatusMessage, setShowStatusMessage] = useState(false);

  const [showExecutionFlowModal, setShowExecutionFlowModal] = useState(false);
  const [showAIModal, setShowAIModal] = useState(false);
  const [showDesignIssuesModal, setShowDesignIssuesModal] = useState(false);
  const [selectedDesignIssueStepId, setSelectedDesignIssueStepId] = useState(null);
  const [pageNO, setPageno] = useState(1);
  const [aiSteps, setAiSteps] = useState([]);
  const [AIMessage, setAIMessage] = useState("");

  const { captureScrollPosition } = useScrollPositionRestore({
    shouldRestore: editItemIndex === null,
    getScrollContainer: getDashboardScrollContainer,
  });

  const [initialEditTab, setInitialEditTab] = useState(0);

  const queryParams = new URLSearchParams(RouteState.search);
  const tcrid = queryParams.get("tcrid");
  const runDate = queryParams.get("date");
  const name = queryParams.get("name");
  const tcname = queryParams.get("tcname");
  const tcRunDate = queryParams.get("tcRundate");

  const TestSuitesBreadCrumbs = [
    <Typography key="3" color="text.primary">
      Execution Reports
    </Typography>,
    <Typography key="3" color="text.primary">
      {`Test Suite - ${name}`} - {`Run date - ${runDate}`}
    </Typography>,
    <Typography key="3" color="text.primary">
      {`Test case - ${tcname} - ${tcRunDate}`}
    </Typography>,
  ];

  const TestCasesBreadCrumbs = [
    <Typography key="3" color="text.primary">
      Execution Reports
    </Typography>,
    <Typography key="3" color="text.primary">
      {`Test case - ${tcname} - ${tcRunDate}`}
    </Typography>,
  ];

  const { data: products, refetch: refetchProductQuery } = useProductQuery();
  const {
    data: latestResult,
    refetch: refetchLatestResult,
    isLoading,
    fetchStatus,
  } = useLastestResultQuery({
    refetchInterval: refreshFlag ? 3000 : false,
    enabled: tcRunDate === null,
  });

  const { data: latestResultForFilteredTestCase } = useLatestResultByTestCaseQuery(
    selectedTestCase,
    { enabled: isFiltered && !!selectedTestCase && tcrid === null },
  );

  const { data: modules, refetch: refetchModuleQuery } = useModuleQuery(selectedProduct, {
    enabled: selectedProduct !== "",
  });

  const { refetch: handleStopTSExecution } = useStopTestSuiteQuery(
    latestResult?.result?.idtest_case_results,
    "case",
    {
      onUnauthorized: () => {
        notify("You are not authorized to stop a test case started by another user.", "error");
      },
    },
  );

  const {
    data: testCasesData,
    refetch: executionReportFetch,
    isSuccess: isGetTestCaseResultSuccess,
  } = useSearchTestCaseRecordsQuery(selectedTestCase, {
    enabled: selectedTestCase !== "" && tcrid === null && selectedTestCase !== null,
  });

  const { data: testStepResults } = useTestCaseResultsQuery(selectedTestCase, {
    enabled: selectedTestCase !== null,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchKeyword(testCaseSearchKeyword);
    }, 500);

    return () => clearTimeout(timer);
  }, [testCaseSearchKeyword]);

  const { data: testCases, refetch: refetchTestCases } = useTestCaseQuery(
    selectedModule,
    debouncedSearchKeyword,
    { enabled: selectedModule !== "" && selectedModule !== 0 },
  );

  const { data: oneTimeTestCaseObject, isSuccess: isGetTestStepResultSuccess } =
    useTestStepSearchQuery(tcrid, {
      enabled: tcrid !== null || editStep !== null,
    });

  const { mutate: executeTest, isSuccess: isExecuteSuccess } = useExecuteTCQuery();
  const { mutate: executeMobileTc, isSuccess: isExecuteMobileTcSuccess } =
    useExecuteMobileTCQuery();
  const { mutate: analysisTest, isSuccess: isAnalysisSuccess } = useAnalysisQuery();

  const { data: testStepResult, refetch: refetchTestStepResult } =
    useFetchTestStepResultQuery(tcrid);

  const { data: historicalResult } = useFetchTestCaseResultQuery(tcrid, {
    enabled: !!tcrid, // only call when tcrid exists
  });

  const isDebugMode = useSelector((state) => state.executionSlice.isDebugMode);
  const debugStepNumber = useSelector((state) => state.executionSlice.debugStepNumber);
  const debugMode = useSelector((state) => state.executionSlice.debugMode);

  const allTestSteps = useSelector((state) => state.executionReport?.allTestSteps || []);
  const executedStepIds = useSelector((state) => state.executionReport?.executedStepIds || []);

  const { data: debugMessageData } = useDebugMessageQuery(
    latestResult?.result?.idtest_case_results,
    {
      enabled:
        isDebugMode &&
        latestResult?.result?.idtest_case_results &&
        (latestResult?.result?.Status === "STARTED" || latestResult?.result?.Status === "RUNNING"),
    },
  );

  const { data: uiDesignIssues, isLoading: isLoadingDesignIssues } = useGetUIDesignIssuesQuery(
    latestResult?.result?.idtest_case_results || tcrid,
    selectedDesignIssueStepId,
    {
      enabled:
        !!(latestResult?.result?.idtest_case_results || tcrid) && !!selectedDesignIssueStepId,
    },
  );

  const { data: executionStatusMessage } = useGetStatusMessageQuery(
    latestResult?.result?.idtest_case_results,
    {
      enabled:
        refreshFlag &&
        latestResult?.result?.idtest_case_results &&
        (latestResult?.result?.Status === "STARTED" || latestResult?.result?.Status === "RUNNING"),
      refetchInterval:
        refreshFlag &&
        latestResult?.result?.idtest_case_results &&
        (latestResult?.result?.Status === "STARTED" || latestResult?.result?.Status === "RUNNING")
          ? 1000
          : false,
    },
  );

  const { mutate: performDebugAction } = useDebugActionQuery();

  useEffect(() => {
    if (executionStatusMessage?.executionmessage) {
      setStatusMessage(executionStatusMessage.executionmessage);
      setShowStatusMessage(true);
    }
  }, [executionStatusMessage]);

  useEffect(() => {
    setEditStep("");
    setEditItemIndex(null);
  }, []);

  useEffect(() => {
    const latestStatus = latestResult?.result?.Status;
    const isLatestExecutionActive = latestStatus === "STARTED" || latestStatus === "RUNNING";
    const shouldSkipLatestResultSync = false;

    if (!shouldSkipLatestResultSync && fetchStatus !== "fetching" && latestResult) {
      const valuesArray = Object.values(latestResult?.data || {});
      if (JSON.stringify(valuesArray) !== JSON.stringify(testcaseResults)) {
        dispatch(setTestCaseResults(valuesArray));
      }
    }
    if (isLatestExecutionActive) {
      setIsExecute(true);
      if (isExecutionPending) {
        setIsExecutionPending(false);
      }
    } else if (!isExecutionPending) {
      setIsExecute(false);

      const isMultiBrowserRun = latestResult?.result?.Browser === "ALL";

      if (latestStatus && !isMultiBrowserRun) {
        setRefreshFlag(false);
      }
    }
  }, [fetchStatus, latestResult, dispatch, testcaseResults, isExecutionPending]);

  useEffect(() => {
    const isAgent =
      latestResult?.isAgent === "true" &&
      ["RUNNING", "STARTED"].includes(latestResult?.result?.Status);
    if (isAgent && latestResult?.AISteps) {
      const stepsArray = Object.entries(latestResult.AISteps).map(([text, status]) => ({
        text,
        status,
      }));
      setAiSteps(stepsArray);
      if (latestResult.AIMessage) {
        setAIMessage(latestResult.AIMessage);
      }
      setShowAIModal(true);
    } else {
      setAiSteps([]);
    }
  }, [latestResult]);

  useEffect(() => {
    if (isGetTestStepResultSuccess) {
      dispatch(setTestCaseResults(testStepResult));
    }
  }, [dispatch, isGetTestStepResultSuccess, testStepResult]);

  useEffect(() => {
    if (!products || products.length === 0) {
      refetchProductQuery();
    }
  }, []);

  useEffect(() => {
    if (!RouteState?.state?.isExecuteClick) return;

    setIsExecutionPending(true);
    setIsExecute(true);
    setIsFiltered(false);
    dispatch(setTestCaseResults([]));
    setRefreshFlag(true);
  }, [RouteState?.state?.isExecuteClick, dispatch]);

  useEffect(() => {
    if (!RouteState?.state?.fromTestStudio) return;

    const isRunning = RouteState?.state?.isExecuteClick;

    if (isRunning) {
      setIsExecute(true);
      setIsExecutionPending(true);
      setRefreshFlag(true);
      dispatch(setTestCaseResults([]));
    } else {
      setIsFiltered(true);
      setRefreshFlag(false);
      setIsExecutionPending(false);
    }

    setTestCaseSearchKeyword(RouteState.state.Test_Case);

    if (RouteState.state.idmodules && RouteState.state.idmodules !== "") {
      refetchTestCases(RouteState.state.idmodules, RouteState.state.Test_Case);
    }

    dispatch(setSelectedProduct(RouteState.state.idproducts));
    dispatch(setSelectedComponent(RouteState.state.idmodules));
    dispatch(setSelectedTestCase(RouteState.state.idtest_case));
    dispatch(setSelectedTestCaseName(RouteState.state.Test_Case));

    if (isRunning) {
      refetchLatestResult();
    }
  }, [RouteState?.state?.fromTestStudio]);

  useEffect(() => {
    if (!RouteState?.state?.isExecuteClick && !RouteState?.state?.fromTestStudio) return;

    if (RouteState?.state?.isExecuteClick) {
      setIsFiltered(false);
    }

    if (
      (latestResult?.result?.Status === "STARTED" ||
        latestResult?.result?.Status === "RUNNING" ||
        latestResult?.result?.Status === undefined) &&
      isExecute
    ) {
      window.ExecuteTimer = setInterval(() => {
        refetchLatestResult();
      }, 5000);
    }

    return () => clearInterval(window.ExecuteTimer);
  }, [
    RouteState?.state?.isExecuteClick,
    RouteState?.state?.fromTestStudio,
    latestResult?.result?.Status,
    isExecute,
    refetchLatestResult,
    dispatch,
  ]);

  useEffect(() => {
    const status = latestResult?.result?.Status;
    const isTerminal =
      status !== "STARTED" && status !== "RUNNING" && status !== undefined && status !== null;

    if (RouteState?.state?.fromTestStudio && RouteState?.state?.isExecuteClick && isTerminal) {
      const timer = setTimeout(() => {
        navigate(RouteState.pathname, { replace: true });
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [
    RouteState?.state?.fromTestStudio,
    RouteState?.state?.isExecuteClick,
    latestResult?.result?.Status,
    navigate,
    RouteState?.pathname,
  ]);

  useEffect(() => {
    if (RouteState?.state?.fromTestStudio) return;

    if (selectedProduct !== "") {
      refetchModuleQuery();
    }

    const productChanged =
      previousProductRef.current !== "" && previousProductRef.current !== selectedProduct;

    if (productChanged && isProductSetInitially) {
      setTestCaseSearchKeyword("");
    }

    previousProductRef.current = selectedProduct;
  }, [refetchModuleQuery, selectedProduct, RouteState?.state?.fromTestStudio]);

  useEffect(() => {
    if (
      !selectedProduct &&
      latestResult &&
      !isProductSetInitially &&
      !RouteState?.state?.fromTestStudio &&
      !isExecutionPending
    ) {
      const valuesArray = Object.values(latestResult.data);
      setTestCaseSearchKeyword(latestResult.testcase.Test_Case);
      dispatch(setTestCaseResults(valuesArray));
      dispatch(setSelectedProduct(latestResult.Product));
      dispatch(setSelectedComponent(latestResult.Modules));
      dispatch(setSelectedTestCase(latestResult.Testcase));
      dispatch(setSelectedTestCaseName(latestResult.testcase.Test_Case));
      setIsProductSetInitially(true);
    }
  }, [
    latestResult,
    dispatch,
    selectedProduct,
    isProductSetInitially,
    refetchTestCases,
    selectedModule,
    RouteState?.state?.fromTestStudio,
    isExecutionPending,
  ]);

  useEffect(() => {
    if (selectedModule) refetchTestCases(selectedModule, testCaseSearchKeyword);
  }, [refetchTestCases, selectedModule]);

  useEffect(() => {
    if (tcrid && oneTimeTestCaseObject) {
      setRefreshFlag(false);
      setIsFiltered(true);
      dispatch(setSelectedProduct(oneTimeTestCaseObject[0].Product));
      dispatch(setSelectedComponent(oneTimeTestCaseObject[0].Modules));
      dispatch(setSelectedTestCase(oneTimeTestCaseObject[0].Testcase));
    }
  }, [tcrid, dispatch, oneTimeTestCaseObject]);

  useEffect(() => {
    if (tcrid) {
      refetchTestStepResult(tcrid);
    }
  }, [refetchTestStepResult, tcrid]);

  useEffect(() => {
    if (editCardData) setCurrentEditItem(editCardData?.[editItemIndex]);
  }, [editCardData, editItemIndex]);

  useEffect(() => {
    if (isExecuteSuccess || isAnalysisSuccess || isExecuteMobileTcSuccess)
      navigate("/new/reports", {
        state: { isExecuteClick: true, product: selectedProduct },
      });
  }, [isExecuteSuccess, isAnalysisSuccess, isExecuteMobileTcSuccess, navigate, selectedProduct]);

  useEffect(() => {
    return () => {
      dispatch(resetExecutionReport());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (RouteState?.state?.isDebug && !isDebugMode) {
      dispatch(setIsDebugMode(true));
      if (RouteState?.state?.debugStepNumber) {
        dispatch(setDebugStepNumber(RouteState?.state?.debugStepNumber));
      }
      if (RouteState?.state?.debugMode) {
        dispatch(setDebugMode(RouteState?.state?.debugMode));
      }
    }
  }, [RouteState?.state, dispatch, isDebugMode]);

  useEffect(() => {
    if (
      debugMessageData?.debugmessage &&
      latestResult?.result?.idtest_case_results &&
      (latestResult?.result?.Status === "STARTED" || latestResult?.result?.Status === "RUNNING")
    ) {
      if (debugMessage !== debugMessageData.debugmessage) {
        setDebugMessage(debugMessageData.debugmessage);
        setShowDebugPrompt(true);
      }
    }
  }, [
    debugMessageData,
    latestResult?.result?.Status,
    latestResult?.result?.idtest_case_results,
    debugMessage,
  ]);

  useEffect(() => {
    if (testcaseResults?.length) {
      const newExecutedSteps = new Set();
      testcaseResults.forEach((step) => {
        if (step.Status === "PASS" || step.Status === "FAIL") {
          newExecutedSteps.add(step.idtest_step);
        }
      });

      if (newExecutedSteps.size > 0) {
        newExecutedSteps.forEach((stepId) => {
          if (!executedStepIds.includes(stepId)) {
            dispatch(addExecutedStep(stepId));
          }
        });
      }
    }
  }, [testcaseResults, dispatch, executedStepIds]);

  useEffect(() => {
    if (
      (isDebugMode && latestResult?.result?.Status === "STARTED") ||
      (isDebugMode && latestResult?.result?.Status === "RUNNING")
    ) {
      setShowDebugIndicator(true);
    } else {
      setShowDebugIndicator(false);
    }
  }, [isDebugMode, latestResult?.result?.Status]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    setAnchorEl(null);
  };

  const handleEdit = (dataList, currentItemIndex, initialTab = 0) => {
    captureScrollPosition();

    setInitialEditTab(initialTab);
    setRefreshFlag(false);
    setEditStep(true);
    if (tcrid) {
      refetchTestStepResult(tcrid);
    }

    const dataEntries = Array.isArray(dataList) ? dataList : Object.values(dataList.data);
    setEditCardData(dataEntries);

    const currentEditItem = dataEntries[currentItemIndex];
    setEditItemIndex(currentItemIndex);
    setCurrentEditItem(currentEditItem);
  };

  const handleExitEdit = () => {
    setEditItemIndex(null);
  };

  const handleViewDivergence = () => {
    if (!testcaseResults?.length) return;
    const idx = testcaseResults.findIndex((s) => s.divergentStep === true);
    if (idx === -1) return;
    const step = testcaseResults[idx];
    // const isFail = step?.test_step_status?.toUpperCase() === "FAIL";
    const isFail = step?.Status?.toUpperCase() === "FAIL";

    const divergenceIndex = isFail ? 4 : 3;
    handleEdit(testcaseResults, idx, divergenceIndex);
  };

  const handleExecute = () => {
    const selectedItem = testStepResults.testcase;

    setIsExecutionPending(true);
    setIsExecute(true);
    setIsFiltered(false);
    dispatch(setTestCaseResults([]));
    setRefreshFlag(true);

    if (selectedItem.case_Type === "MOBILE") {
      executeMobileTc({
        Test_Case_Id: selectedItem.idtest_case,
        isDebug: isDebugMode,
        debugStepNumber: debugStepNumber,
        debugMode: debugMode,
      });
      return;
    }

    const obj = {
      id: selectedItem?.idtest_case,
      SelectEnvironmentName: selectedItem.envname,
      SelectEnvironmentUrl: selectedItem.envurl,
      SelectBrowserName: selectedItem.browser,
      SelectResolution: selectedItem.SelectResolution,
      SelectRunonce: selectedItem.multirun,
      testcase: selectedItem.Test_Case,
    };
    executeTest(obj);
  };

  const handleAnalysis = () => {
    const selectedItem = testStepResults.testcase;
    const obj = {
      id: selectedItem?.idtest_case,
      SelectEnvironmentName: selectedItem.envname,
      SelectEnvironmentUrl: selectedItem.envurl,
      SelectBrowserName: selectedItem.browser,
      SelectResolution: selectedItem.SelectResolution,
      SelectRunonce: selectedItem.multirun,
      testcase: selectedItem.Test_Case,
    };
    setIsExecutionPending(true);
    setIsFiltered(false);
    dispatch(setTestCaseResults([]));
    setRefreshFlag(true);
    analysisTest(obj);
    setIsExecute(true);
    handleMenuClose();
  };

  const handleCurrentExecution = () => {
    const url = "/new/reports/current-executions";
    window.open(url, "_blank");
    handleMenuClose();
  };

  const handleViewTestCase = () => {
    navigate("/new/test-studio", {
      state: {
        fromExecutionReports: true,
        idproducts: selectedProduct,
        idmodules: selectedModule,
        idtest_case: selectedTestCase,
        Test_Case: selectedTestCaseName,
      },
    });
  };

  const handleConfirmStopExecution = () => {
    handleStopTSExecution();
    setOpenStopDialog(false);
  };

  const handleCancelStopExecution = () => {
    setOpenStopDialog(false);
  };

  const isFilteredToTestCase = isFiltered && !!selectedTestCase;
  const filteredResult = latestResultForFilteredTestCase?.result;

  const statusBarData = tcrid
    ? historicalResult?.result // history mode
    : isFilteredToTestCase
      ? filteredResult // filtered test scenario mode (null while loading)
      : latestResult?.result; // current behavior (company-wide latest)

  const testCaseId = tcrid
    ? historicalResult?.testcase?.idtest_case
    : isFilteredToTestCase
      ? selectedTestCase
      : latestResult?.testcase?.idtest_case;

  const testCaseResultId = tcrid
    ? tcrid
    : isFilteredToTestCase
      ? filteredResult?.idtest_case_results
      : latestResult?.result?.idtest_case_results;
  const { refetch: refetchDownloadTestCaseReport } = useDownloadTestCaseQuery(
    testCaseResultId,
    "PDF",
  );
  const logFileUrl = sessionStorage.getItem("logFileFromExeTestCaseReports");

  const handleViewLogFile = () => {
    openAuthedResource(logFileUrl, {
      filename: `${tcname || "test-case"}.log`,
    }).catch((error) => notify(error.message || "Failed to open the log file.", "error"));
  };

  const handleDebugAction = (action) => {
    if (
      !latestResult?.result?.idtest_case_results ||
      !(latestResult?.result?.Status === "STARTED" || latestResult?.result?.Status === "RUNNING")
    ) {
      return;
    }

    performDebugAction({
      tcrid: latestResult.result.idtest_case_results,
      option: action.option,
      idtest_step: action.idtest_step,
    });
    setShowDebugPrompt(false);
  };

  const handleDebugModalClose = () => {
    setShowDebugPrompt(false);
    setDebugActionReminder(true);
    setTimeout(() => setDebugActionReminder(false), 5000);
  };

  const handleDebugIndicatorClick = () => {
    setShowDebugPrompt(true);
  };

  const removeheader = () => {
    setShowLatestRun(false);
  };

  const handleDownloadReport = () => {
    if (!testCaseResultId) return;
    refetchDownloadTestCaseReport();
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {(latestResult?.result?.Status === "STARTED" ||
        latestResult?.result?.Status === "RUNNING") && (
        <Box sx={{ mb: 3 }}>
          <Box display="flex" gap={2} alignItems="center" mt={2}>
            <Tooltip title="Stop Execution">
              <StyledButton
                variant="contained"
                onClick={() => setOpenStopDialog(true)}
                color="warning"
                endIcon={<Stop />}
                sx={{
                  backgroundColor: "#ff5336",
                  boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
                }}
              >
                Stop
              </StyledButton>
            </Tooltip>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "#f0f7ff",
                border: "1px solid #2550d1",
                borderRadius: "8px",
                padding: "12px 20px",
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:
                    latestResult?.result?.Status === "RUNNING" ? "#4caf50" : "#ff9800",
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%, 100%": { opacity: 1 },
                    "50%": { opacity: 0.5 },
                  },
                }}
              />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#2B3539",
                }}
              >
                Running: <strong>{latestResult?.result?.testcase || "Test Case"}</strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#8089A8",
                  backgroundColor: "#e3f2fd",
                  padding: "2px 8px",
                  borderRadius: "4px",
                }}
              >
                {latestResult?.result?.Status}
              </Typography>
            </Box>
          </Box>
          <DebugConfigModal
            open={showDebugPrompt}
            onClose={handleDebugModalClose}
            onDebugAction={handleDebugAction}
            testSteps={allTestSteps.filter((step) => !executedStepIds.includes(step.idtest_step))}
            isExecutionReports={true}
            debugMessage={debugMessage}
            onStopExecution={handleConfirmStopExecution}
            initialConfig={{
              isDebugMode: true,
              debugMode: "resumeafter",
              selectedStepId: selectedStepId,
            }}
          />

          <Snackbar
            open={showStatusMessage}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ mt: 8 }}
            key={statusMessage}
          >
            <Alert severity="success" sx={{ width: "100%" }}>
              {statusMessage}
            </Alert>
          </Snackbar>
          <Snackbar
            open={debugActionReminder}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ mt: 8 }}
          >
            <Alert severity="info" sx={{ width: "100%" }}>
              Debug mode is active. Please select a debug action to continue execution.
            </Alert>
          </Snackbar>
        </Box>
      )}

      {showDebugIndicator && (
        <DebugModeIndicator onClick={handleDebugIndicatorClick}>
          <Typography variant="body2" fontWeight={500}>
            Debug Mode Active - Click to Open Debug Actions
          </Typography>
        </DebugModeIndicator>
      )}

      {editItemIndex === null ? (
        <Box>
          <Box
            sx={{
              position: "sticky",
              top: "15px",
              zIndex: 100,
              backgroundColor: "#fff",
              pb: 1,
              pt: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Box display="flex" alignItems="center" justifyContent={"space-between"}>
              <Box display="flex" columnGap={3} alignItems={"center"}>
                {!tcrid && (
                  <ReportSelection
                    setRefreshFlag={setRefreshFlag}
                    testCases={testCases}
                    refetchTestCases={refetchTestCases}
                    test
                    testCaseSearchKeyword={testCaseSearchKeyword}
                    setTestCaseSearchKeyword={setTestCaseSearchKeyword}
                    products={products}
                    modules={modules}
                    executionReportFetch={executionReportFetch}
                    setIsFiltered={setIsFiltered}
                    oneTimeTestCaseObject={oneTimeTestCaseObject}
                    setPageno={setPageno}
                    removeheader={removeheader}
                  />
                )}
                {tcRunDate && (
                  <Box>
                    <PageTitle title={tcname} variant="h4" mb={2} />
                    <CustomBreadcrumbs ariaLabel="breadcrumb">
                      {name ? TestSuitesBreadCrumbs : TestCasesBreadCrumbs}
                    </CustomBreadcrumbs>
                  </Box>
                )}
              </Box>

              {selectedTestCase && (
                <Box display={"flex"} columnGap={"1rem"} alignItems="center">
                  <Box>
                    {refreshFlag ? (
                      <IconContainer
                        handleClick={() => {
                          setRefreshFlag(false);
                          clearInterval(window.ExecuteTimer);
                        }}
                        tooltipText="Stop Refresh"
                      >
                        <SyncDisabledIcon />
                      </IconContainer>
                    ) : (
                      <IconContainer
                        handleClick={() => {
                          setRefreshFlag(true);
                        }}
                        tooltipText="Refresh"
                      >
                        <RefreshIcon />
                      </IconContainer>
                    )}
                  </Box>
                  <Box>
                    <IconContainer handleClick={handleViewTestCase} tooltipText={"View Test Case"}>
                      <VisibilityIcon />
                    </IconContainer>
                  </Box>
                  {logFileUrl && tcRunDate && (
                    <IconContainer handleClick={handleViewLogFile} tooltipText={"View Log"}>
                      <LogFileIcon />
                    </IconContainer>
                  )}
                  {latestResult?.result?.Status !== "STARTED" &&
                    latestResult?.result?.Status !== "RUNNING" && (
                      <Box>
                        <Tooltip title="Run Test Case">
                          <StyledButton
                            variant="contained"
                            onClick={handleExecute}
                            color="warning"
                            endIcon={<ExportIcon />}
                            sx={{
                              backgroundColor: "#ff5336",
                              boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
                            }}
                          >
                            Run
                          </StyledButton>
                        </Tooltip>
                      </Box>
                    )}
                  {latestResult?.result?.Status !== "STARTED" &&
                    latestResult?.result?.Status !== "RUNNING" && (
                      <Box>
                        <Tooltip title="Download Report">
                          <StyledButton
                            variant="contained"
                            onClick={handleDownloadReport}
                            endIcon={<FileDownloadIcon />}
                            size="small"
                            sx={{
                              backgroundColor: "#2550d1",
                              boxShadow: "0px 16px 30.6px 0px rgba(37, 80, 209, 0.27)",
                              padding: "8px 16px",
                              fontSize: "14px",
                            }}
                          >
                            Download
                          </StyledButton>
                        </Tooltip>
                      </Box>
                    )}
                  <Box onClick={handleMenuClick}>
                    <IconContainerCircle tooltipText="More Options">
                      <ContextIcon />
                    </IconContainerCircle>
                  </Box>
                  {latestResult?.result && (
                    <Tooltip title="Review Test Flow">
                      <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={() => setShowExecutionFlowModal(true)}
                        endIcon={<TimelineIcon />}
                        sx={{
                          backgroundColor: "#2550d1",
                          boxShadow: "0px 16px 30.6px 0px rgba(37, 80, 209, 0.27)",
                        }}
                      >
                        Review Flow
                      </StyledButton>
                    </Tooltip>
                  )}
                  {latestResult?.isAgent === "true" && aiSteps.length > 0 && (
                    <Tooltip title="View AI Steps">
                      <StyledButton
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowAIModal(true)}
                        endIcon={<TimelineIcon />}
                        size="small"
                        sx={{
                          backgroundColor: "#9C27B0",
                          boxShadow: "0px 16px 30.6px 0px rgba(156, 39, 176, 0.27)",
                          padding: "8px 16px",
                          fontSize: "14px",
                          minWidth: "120px",
                        }}
                      >
                        AI Steps
                      </StyledButton>
                    </Tooltip>
                  )}
                </Box>
              )}
              <ExeMenu
                anchorEl={anchorEl}
                handleClose={handleMenuClose}
                handleAnalysis={handleAnalysis}
                setRefreshFlag={setRefreshFlag}
                handleCurrentExecution={handleCurrentExecution}
                selectedTestCaseName={selectedTestCaseName}
              />
            </Box>
          </Box>

          {/* {!isLoading && latestResult && !isFiltered && ( */}
          <Box mt={3}>
            <StatusBar
              data={statusBarData}
              testcaseid={testCaseId}
              testcaseresultId={testCaseResultId}
              onViewDivergence={handleViewDivergence}
            />
          </Box>
          {/* )} */}
          {isExecutionPending && !testcaseResults?.length && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="140px"
              mt={2}
            >
              <Typography color="#8089A8">
                Execution started. Waiting for live results...
              </Typography>
            </Box>
          )}
          {(tcrid === null && !isFiltered && selectedTestCase && !oneTimeTestCaseObject?.length) ||
          (!isFiltered && testcaseResults?.length) ? (
            <Box ref={containerRef} display="flex" columnGap={4} flexWrap="wrap" rowGap={4} mt={3}>
              {testcaseResults &&
                testcaseResults.map((data, index) => {
                  return (
                    <TestItemCard
                      item={data}
                      index={index}
                      key={index}
                      handleEdit={() => handleEdit(testcaseResults, index)}
                      handleViewDesignIssues={(item) => {
                        setSelectedDesignIssueStepId(item.idtest_step_result);
                        setShowDesignIssuesModal(true);
                      }}
                      designPrincipals={!!latestResult?.testcase?.designPrincipals}
                      width={itemWidth}
                    />
                  );
                })}
            </Box>
          ) : null}
          {tcrid === null && testCasesData?.length && isGetTestCaseResultSuccess && isFiltered ? (
            <Box display="flex" mt={3}>
              <ExeTestCaseReportsTable
                data={testCasesData}
                isSuccess={isGetTestCaseResultSuccess}
              />
            </Box>
          ) : null}

          {tcrid !== null && testStepResult?.length ? (
            <Box ref={containerRef} display="flex" columnGap={4} flexWrap="wrap" rowGap={4} mt={3}>
              {testStepResult &&
                isGetTestStepResultSuccess &&
                testStepResult.map((item, index) => {
                  return (
                    <TestItemCard
                      item={item}
                      index={index}
                      key={index}
                      handleEdit={() => handleEdit(testStepResult, index)}
                      handleViewDesignIssues={(item) => {
                        setSelectedDesignIssueStepId(item.idtest_step_result);
                        setShowDesignIssuesModal(true);
                      }}
                      designPrincipals={!!latestResult?.testcase?.designPrincipals}
                      width={itemWidth}
                    />
                  );
                })}
            </Box>
          ) : null}

          {!testStepResults?.length && !latestResult && !testcaseResults && (
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"300px"}>
              No data available
            </Box>
          )}
        </Box>
      ) : (
        <Box pb={2} pt={2}>
          <EditHeader
            editItemIndex={editItemIndex}
            editItem={currentEditItem}
            setEditItemIndex={setEditItemIndex}
            EditData={editCardData}
            testCase={selectedTestCaseName}
            onExit={handleExitEdit}
          />
          <EditTabs editItem={currentEditItem} fromExcReports={true} initialTab={initialEditTab} />
        </Box>
      )}

      <CustomDialog
        open={openStopDialog}
        onClose={handleCancelStopExecution}
        title="Stop Execution"
        content={
          <Typography>Are you sure you want to stop execution of this test case?</Typography>
        }
        actions={
          <>
            <Button onClick={handleConfirmStopExecution}>Yes</Button>
            <Button onClick={handleCancelStopExecution}>No</Button>
          </>
        }
      />

      <VisualAnalysisModal
        open={showDesignIssuesModal}
        onClose={() => {
          setShowDesignIssuesModal(false);
          setSelectedDesignIssueStepId(null);
        }}
        isLoading={isLoadingDesignIssues}
        data={uiDesignIssues}
      />

      <ExecutionFlowModal
        open={showExecutionFlowModal}
        onClose={() => setShowExecutionFlowModal(false)}
        tcid={selectedTestCase}
        tcrid={tcrid || testCaseResultId}
        latestRecordings={testStepResults}
      />

      <AIStepsModal
        open={showAIModal}
        onClose={() => setShowAIModal(false)}
        aiSteps={aiSteps}
        tcrid={testCaseResultId}
      />
    </Box>
  );
};

export default ExecutionReports;
